import type { GenericSchema } from 'valibot'
import type { CrystallizeBaseCatalogue } from '~/utils/crystallize/catalogue'
import type { ImageVariant } from '~/utils/crystallize/component-schemas'
import { array, pipe, transform, union } from 'valibot'

// avif first, fallback to webp, png and finally jpg if in a browser without support
const IMAGE_EXTENSION_PRIORITY = ['avif', 'webp', 'png', 'jpg'] as const

/**
 * Get image extension + priority when loading the image.
 *
 * @param url - Raw image url object
 * @param url.url - The URL string of the image
 */
export function getExtAndPriority({ url }: Pick<ImageVariant, 'url'>) {
  const raw = url.split('.').pop()
  const ext = IMAGE_EXTENSION_PRIORITY.find(ext => ext === raw)
  return ext && { ext, priority: IMAGE_EXTENSION_PRIORITY.indexOf(ext) }
}

export function singleChunk<T extends GenericSchema>(schema: T) {
  return pipe(
    union([array(schema), schema]),
    transform(it => Array.isArray(it) ? it[0] : it),
  )
}

export function getSlug(catalogue: CrystallizeBaseCatalogue) {
  return catalogue.path.split('/').filter(Boolean).pop()!
}
